export enum Status {
  Open = 1, // Confirmed
  Cancel = 2,
  Tentative = 3,
  Expired = 4,
  Reserved = 5,
  Request = 6,
}

export enum StatusText {
  Open = 'open', // Confirmed
  Cancel = 'cancel',
  Tentative = 'tentative',
  Expired = 'expired',
  Reserved = 'reserved',
  Request = 'request',
}

export const StatusToText = {
  [Status.Open]: 'Open',
  [Status.Cancel]: 'Cancel',
  [Status.Tentative]: 'Tentative',
  [Status.Expired]: 'Expired',
  [Status.Reserved]: 'Reserved',
  [Status.Request]: 'Request',
};
